import type { IconProps } from '../../../components/Icon/Icon.util';

export const HidePrivacy = ({
  title,
  width = 32,
  height = 32,
  fill = 'none',
  role = 'presentation',
}: IconProps): React.ReactNode => {
  const viewBoxSize = 32;

  return (
    <svg
      fill={fill}
      focusable='false'
      height={height}
      role={role}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      {title ? <title>{title}</title> : null}

      <path d='M30.6348 5.77276C31.0615 5.4222 31.1233 4.79205 30.7728 4.36529C30.4222 3.93852 29.7921 3.87675 29.3653 4.2273L1.36529 27.2273C0.938525 27.5779 0.876746 28.208 1.2273 28.6348C1.57786 29.0615 2.208 29.1233 2.63477 28.7728L30.6348 5.77276Z' />
      <path d='M15.9981 7.00132C17.9643 6.97231 19.9307 7.42386 21.7979 8.17856L20.0741 9.59457C18.7267 9.14523 17.3564 8.89459 16.015 8.91625C16.0038 8.91643 15.9925 8.91643 15.9813 8.91625C11.3891 8.84208 6.45721 11.9596 3.27363 15.3141C3.09746 15.502 3 15.7457 3 15.9982C3 16.2508 3.0975 16.4945 3.27372 16.6824C4.41035 17.8808 5.78627 19.0664 7.30247 20.0856L5.7407 21.3684C4.23186 20.3099 2.88929 19.1257 1.79147 17.968L1.78881 17.9652C1.28101 17.4254 1 16.7247 1 15.9982C1 15.2717 1.28101 14.571 1.78882 14.0312L1.79167 14.0282C5.12814 10.5118 10.5639 6.92115 15.9981 7.00132Z' />
      <path d='M16 10C16.9961 10 17.9354 10.2427 18.7622 10.6722L16.9942 12.1245C16.6763 12.0432 16.3432 12 16 12C13.7909 12 12 13.7909 12 16C12 16.0745 12.002 16.1484 12.0061 16.2219L10.2369 17.6751C10.0827 17.1435 10 16.5814 10 16C10 12.6863 12.6863 10 16 10Z' />
      <path d='M21.9439 15.1763L19.9102 16.8469C19.5265 18.6266 17.9588 19.9659 16.0724 19.9994L14.0368 21.6715C14.6519 21.8844 15.3125 22 16 22C19.3137 22 22 19.3137 22 16C22 15.7206 21.9809 15.4456 21.9439 15.1763Z' />
      <path d='M15.9813 23.0837C14.9303 23.1007 13.8671 22.9525 12.8148 22.6752L11.0325 24.1392C12.6393 24.6993 14.314 25.0235 15.9981 24.9987C21.5221 25.0801 26.9446 21.4074 30.2083 17.9683L30.2112 17.9652C30.719 17.4254 31 16.7247 31 15.9982C31 15.2717 30.719 14.571 30.2112 14.0312L30.2079 14.0278C29.2598 13.0297 28.1429 12.0256 26.905 11.1012L25.3545 12.3747C26.6029 13.275 27.7471 14.2835 28.7266 15.3144C28.9026 15.5022 29 15.7458 29 15.9982C29 16.2507 28.9025 16.4943 28.7264 16.6822C25.6068 19.9688 20.689 23.1591 16.015 23.0837C16.0037 23.0836 15.9925 23.0836 15.9813 23.0837Z' />
    </svg>
  );
};
